import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/rescue',
  component: LAYOUT,
  name: 'rescue',
  redirect: '/rescue/query',
  meta: {
    title: '救援查询',
  },
  children: [
    {
      path: 'query',
      name: 'RescueQuery',
      meta: {
        title: '救援查询',
        keepAlive: true,
      },
      component: () => import('@/views/rescue/query'),
    },
    {
      path: 'location',
      name: 'RescueLocation',
      meta: {
        title: '位置',
        keepAlive: true,
      },
      component: () => import('@/views/rescue/location'),
    },
  ],
};
